module.exports = __webpack_public_path__ + "img/creator.acbb7967.svg";